import { type FC, type ReactNode, useReducer, useEffect } from 'react';

import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

import { Toasts } from './Toasts.tsx';
import { ToastDispatchContext, ToastStateContext } from './context.ts';
import { reducer, initialState } from './reducer.ts';

type ToastProviderProps = {
    children: ReactNode;
    /**
     * Should not be used as pattern, added temporarily
     * and will be cleaned up with AB test
     */
    trackItemFavoriting?: boolean;
};

const ToastProvider: FC<ToastProviderProps> = ({ children, trackItemFavoriting }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (trackItemFavoriting) {
            trackAbTestV2Variant('Favorites_DriveItemFavoritesAdoption_Nov2025');
        }
    }, [trackItemFavoriting]);

    return (
        <ToastDispatchContext.Provider value={dispatch}>
            <ToastStateContext.Provider value={state}>
                {children}
                <Toasts />
            </ToastStateContext.Provider>
        </ToastDispatchContext.Provider>
    );
};

export { ToastProvider };
